import React, { useCallback, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useFeedbackCollector } from '../../../../common/utils/feedback-collector';
import messages from './messages';

export const FEEDBACK_GROUP_ID = 'x2c-other-app-request-form';
export const EmptyView = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();
	const openFeedbackModal = useFeedbackCollector();

	const onSubmitFeedbackClick = useCallback(() => {
		const onSubmit = () => {
			fireUIAnalytics(
				createAnalyticsEvent({
					action: 'clicked',
					actionSubject: 'X2CAppRequestSubmitButton',
				}),
			);
		};

		openFeedbackModal({
			feedbackGroupId: FEEDBACK_GROUP_ID,
			onSubmit,
			feedbackTitle: formatMessage(messages.feedbackTitle),
			customTextAreaLabel: formatMessage(messages.customTextAreaLabel),
		});
	}, [createAnalyticsEvent, formatMessage, openFeedbackModal]);

	const handleClick = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'X2CAppRequestButton',
			}),
		);
		onSubmitFeedbackClick();
	}, [createAnalyticsEvent, onSubmitFeedbackClick]);

	return (
		<Box xcss={emptyMessageStyles}>
			{formatMessage(messages.requestOtherApp, {
				link: (content: ReactNode) => (
					<Button
						appearance="link"
						spacing="none"
						onClick={handleClick}
						testId="project-create-importer-upload-flow.ui.select-source-screen.source-section.empty-view.request-other-app-button"
					>
						{content}
					</Button>
				),
			})}
		</Box>
	);
};

const emptyMessageStyles = xcss({
	font: token('font.body'),
	color: 'color.text',
	padding: 'space.250',
	backgroundColor: 'elevation.surface.sunken',
	borderRadius: 'border.radius.200',
	marginBottom: 'space.200',
});
